import { downloadFile, getDownloadUrl } from 'application/api/helpers'
import { fetchHandler, HTTP_METHOD, limiter, API_VERSION_ESYMANDANT } from 'application/api/request_builders'
import { fetchRequestBuilder } from 'application/api/request_builders'
import { handleApiFilestreamResponse } from 'application/api/response_handlers'

export const downloadMessageAsPdf = (accountId, messageId, messageHeader) => {
    const request = fetchRequestBuilder(`${API_VERSION_ESYMANDANT}/e.consult.${accountId}/messages/${messageId}/pdf`, HTTP_METHOD.GET)

    return limiter.schedule(() => fetchHandler(request.url, request.data))
        .then(handleApiFilestreamResponse)
        .then(getDownloadUrl)
        .then(downloadUrl => {
            downloadFile(downloadUrl, messageHeader + '.pdf')
        })
}